export default "__VITE_ASSET__CiF_GtDf__"